/**
 * Format a number with locale-specific thousands separators.
 * @example formatNumber(2545004) → "2,545,004"
 */
export function formatNumber(n: number): string {
  return new Intl.NumberFormat('en-US').format(n);
}
